package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_05_19_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn conjures 45lbs of oatmeal and plenty of water. The party is relieved that they won’t need to ration their limited packed food during the long journey. While grateful for Falorn’s conjuring, some party members seem disappointed by the blandness and use Prestidigitation to improve the flavor.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The airflow in the tunnel is still good, and our heroes still hear running water. Even more torches now are unlit (prior to Tuesday’s correction).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes approach an outpost on the east side of the cavern. Dirk sees a stables building with an open door. The outpost looks abandoned, and Goram senses that something is amiss because the outpost is normally guarded. Our heroes sneak up on the open door. Goram peers inside the open stables door and sees the partially digested corpse of a horse.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes fight two Vrocks, one inside the stables out outside to the north.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Note: Vrock seems consistent with Monster Manual / ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.dndbeyond.com/monsters/17047-vrock") {
            org.jetbrains.compose.web.dom.Text("https://www.dndbeyond.com/monsters/17047-vrock")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Verified fire resistance")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Verified physical damage resistance")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Experienced Stunning Screech")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Experienced Spores")
        }
    }
}
